import 'jquery.cookie';
import { format } from 'date-fns';

export default (options) => ({
    ga_id: $.cookie('_ga') || 0,
    ya_id: $.cookie('_ym_uid') || 0,
    domain: window.location.host,
    timestamp: options.timestamp ? format(options.timestamp, 'yyyy-MM-dd HH:mm:ss', new Date()) : null,
});